import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ROUTER_TREE } from './core/constants/routes.constant';

import { DataSourcesComponent } from './core/pages/data-sources/data-sources.component';
import { PrivacyPolicyComponent } from './core/pages/privacy-policy/privacy-policy.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/homepage/homepage.module').then((m) => m.HomepageModule)
  },
  {
    path: `${ROUTER_TREE.INSTITUTION}/:id`,
    loadChildren: () =>
      import('./features/institution/institution.module').then((m) => m.InstitutionModule)
  },
  {
    path: ROUTER_TREE.COMPARE,
    loadChildren: () => import('./features/compare/compare.module').then((m) => m.CompareModule)
  },
  {
    path: ROUTER_TREE.INSTITUTIONS,
    loadChildren: () =>
      import('./features/institutions/institutions.module').then((m) => m.InstitutionsModule)
  },
  {
    path: ROUTER_TREE.DATA_SOURCES,
    component: DataSourcesComponent
  },
  {
    path: ROUTER_TREE.PRIVACY_POLICY,
    component: PrivacyPolicyComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
